module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="btn-group btn-block" ng-class="::{\'dropup\': scaleselectorCtrl.options.dropup}">\n  <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">\n    <span ng-bind-html="scaleselectorCtrl.currentScale | ngeoScalify | ngeoTrustHtml"></span>\n  </button>\n  <ul class="dropdown-menu btn-block" role="menu">\n    <li ng-repeat="zoomLevel in ::scaleselectorCtrl.zoomLevels">\n      <a href ng-click="scaleselectorCtrl.changeZoom(zoomLevel)"\n         ng-bind-html="scaleselectorCtrl.getScale(zoomLevel) | ngeoScalify | ngeoTrustHtml">\n      </a>\n    </li>\n  </ul>\n</div>\n';

}
return __p
}